// extracted by mini-css-extract-plugin
module.exports = {"container":"te","list":"ue"};